import React, { useEffect } from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

// Services
import campaignService from "services/campaignService";

function BlueskyButton() {
  // State
  const campaignConfig = useSelector((state) => state.campaignConfig.value);
  const region = useSelector((state) => state.region.value);

  if (_.isBlank(campaignConfig) || _.isBlank(region)) {
    return null;
  }

  const share = () => {
    const sharingHost = _.get(campaignConfig, `social.sharingHost`);
    const absoluteShareUrl = _.get(campaignConfig, `social.absoluteShareUrl`);

    const shareUrl = [
      sharingHost,
      "sharing",
      campaignService.getLanguageCode(),
      campaignService.getCampaignName(),
      "content",
      region,
    ].join("/");

    const blueskyText = `${_.get(campaignConfig, "social.blueskyText")}\n\n${absoluteShareUrl || shareUrl}`;

    window.open(
      `https://bsky.app/intent/compose?text=${encodeURIComponent(blueskyText)}`,
    );
  };

  return (
    <button className="ShareButton BlueskyButton" onClick={share}>
      <img src={require("images/bluesky.png")} />
    </button>
  );
}

export default BlueskyButton;
